module.exports = {
      id: "pisces-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#pisces",
      toString: function () {
        return this.url;
      }
    }